var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-capitalize font-weight-bold font-cl px-12 py-3",staticStyle:{"font-size":"clamp(14px, 2.5vw, 14px)"},attrs:{"height":"52","min-width":"254","outlined":"","color":_vm.color,"tile":""}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }